<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>提现</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
      <!-- <el-button  size='mini' type="text" style="" @click="backClick">返回</el-button> -->
    </div>
    <div class="tiShiBox">
      <div style="margin: 10px 0 0 20px">
        <span>提示：</span><br />
        <span>1.单笔提现金额不得超过5万，24小时内可到账。</span><br />
        <span>2.每天23:00至次日00:00不提供提现服务。</span>
      </div>
    </div>
    <div style="margin: 20px 0 0 15px">
      <p>
        可提现余额：&nbsp;&nbsp;<span style="color: red; font-size: 18px">{{
          topData.accountMoney
        }}</span
        >&nbsp;&nbsp;元
      </p>
    </div>
    <div style="margin: 20px 0 0 15px">
      <p>提现到：</p>
    </div>
    <div class="bankBox">
      <p class="bank">{{ topData.ext2 }}</p>
      <p class="bankcard">卡号：{{ bankAccount }}</p>
    </div>
    <div>
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
      <el-tabs v-model="activeName" >
     <el-tab-pane label="提现单据" name="first">
          <div>
            <!-- <p style="margin-left: 18px">请选择提现订单：</p> -->
          <el-table
          height="300px"
          border
          bordersize="mini"
          size="mini"
          ref="tableref"
          :data="tableData"
          style="width:100%"
          class="elTab"
          @row-click="dianjixuanzhong"
          @selection-change="selectGoods"
          highlight-current-row
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
        <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="业务单号" align="center" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="结算量" align="center">
            <template slot-scope="scope">
            <span>{{scope.row.weight}}{{scope.row.unitMeasurement}}</span>
          </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="pricingMethod" label="计价方式" align="center">
            <template slot-scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod == '1'">单价</span>
            <span v-if="scope.row.pricingMethod == '2'">包干</span>
            </div>
          </template>
          </el-table-column>
          <el-table-column property="unitPrice" width="100"     label="单价">
          <template scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.pricingMethod==2">-</span>
            </div>
          </template>
        </el-table-column>
          <el-table-column  prop="totalAmount" label="应收合计(元)" :formatter="emptyFn" align="center" ></el-table-column>
          <el-table-column  prop="updateTime" label="收款时间" :formatter="dateTimeFormat"  align="center"></el-table-column>
        </el-table>
            <!--分页-->
    <div class="pags" style="text-align: left">
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-sizes="[1, 10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
          </div>

        </el-tab-pane>

  </el-tabs>

    </div>

    <div style="margin-left: 18px">
      <p>
        已选提现金额：
        <span style="color: red; font-size: 18px">{{ allMoney }}</span>
        &nbsp;&nbsp;元
      </p>
    </div>
    <div>
      <el-form
        :model="tiXianFrom"
        :rules="rules"
        :validate-on-rule-change="false"
        ref="tiXianFrom"
        class="demo-form-inline"
        label-width="90px"
        size="mini"
      >
        <!-- <el-form-item label="提现金额:" prop="money" style="margin-top:20px;">
            <el-input   placeholder="" v-number-input.float="3" maxlength=""  v-model.trim="tiXianFrom.money" style="width:200px;"></el-input>
          </el-form-item> -->
        <el-form-item label="交易密码:" prop="pwd" style="margin-top: 20px">
          <el-input
            show-password
            placeholder=""
            auto-complete="new-password"
            v-number-input.float="0"
            maxlength="6"
            v-model.trim="tiXianFrom.pwd"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button
        size="mini"
        type="primary"
        style="margin: 10px 0 0 15px"
        @click="tiXianClick"
        :loading="tiXianLoading"
        >确认提现</el-button
      >
      <!-- <el-button  size='mini' type="primary" style="" @click="backClick">返回</el-button> -->
    </div>
    <!-- 提示弹窗 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="tiShiMark"
      @close="closeDialog"
      width="500px"
      center
    >
      <span>
        <div style="margin: 20px 0 0 100px">
          提交成功！24小时内可到账，请耐心等候。
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tiShiClose" type="primary" size="mini"
          >确定</el-button
        >
      </span>
    </el-dialog>
       <!-- 支付状态 -->
   <el-dialog  title="提现状态"  :visible.sync="zfztMark" width="800" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
        <div class="table">
          <el-table :data="zfztList"   bordersize="mini"  :row-class-name="tableRowClassName"
            style="width: 100%" center border>
            <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
            <el-table-column property="businessNo"   :formatter="emptyFn"   label="业务编号"></el-table-column>
            <el-table-column property="zfzt"  :formatter="emptyFn"   label="提现状态"></el-table-column>
            <el-table-column property="res"   :formatter="emptyFn"   label="状态说明"></el-table-column>
          </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="zfztMark = false">关闭</el-button>
      </span>
   </el-dialog>
  </div>
</template>
<script>
import {
  getPayDetailByPC,
  downstreamSettlementList,
  sOrderList, // 列表-车队订单
  addWithdrawal1 // 提现
} from '@/api/consignment'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn, dateTimeFormat } from '@/utils/util'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
import { get } from 'store'
export default {
  data () {
    return {
      idArr: [],
      orderbillNoArr: [],
      drawalMoneyArr: [],
      zfztList: [],
      loading: false,
      zfztMark: false,
      number: 0,
      activeName: 'first',
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      // 按钮
      tableDataD: [],
      btnFlg: [],
      btnIdArr: [
        '00DP003B001',
        '00DP003B002',
        '00DP003B003',
        '00DP003B004',
        '00DP003B005',
        '00DP003B006'
      ],
      editableTabs: [],
      editableTabsValue: 'first',
      title: '',
      h: '500px',
      searchFrom1: {
        defaultCno: '',
        pageNo: 1,
        pageSize: 10
      },
      money: '',
      bankAccount: '',
      tiXianFrom: {
        money: '',
        pwd: ''
      },
      rules: {
        pwd: [
          { required: true, message: '请输入交易密码', trigger: 'blur' }
        ]
      },
      topData: {},
      tiXianLoading: false,
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      allMoney: 0,
      seleData: [],
      tiShiMark: false
    }
  },
  mounted () {},
  created () {
    this.getTopData()
  },
  methods: {
    getTopData () {
      getPayDetailByPC({
        accountType: 4 // 账户类型1-货主 2-司机 3-车队  4-车队长
      })
        .then((res) => {
          this.bankAccount = res.bankAccount
          this.topData = res
          this.getListData()
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 点击每行
    dianjixuanzhong (row, column, event) {
      // this.$refs.spuTableList.toggleRowSelection(row)
    },
    // 选择数据
    selectGoods (selection, row) {
      // let arr = []
      this.seleData = []
      selection.forEach((item, index) => {
        if (this.number == 0) { // 运单
          this.seleData.push(item.totalAmount)
        } else {
          this.seleData.push(item.totalAmount)
        }
      })
      this.allMoney = this.sum(this.seleData).toFixed(2)
    },
    selectGoodsD (selection, row) {
      // let arr = []
      this.seleData = []
      selection.forEach((item, index) => {
        if (this.number == 0) { // 运单
          this.seleData.push(item.actualFatePrice)
        } else {
          this.seleData.push(item.totalAmount)
        }
      })
      this.allMoney = this.sum(this.seleData).toFixed(2)
    },
    // 获取列表
    getListData () {
      downstreamSettlementList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        settlementStatus: 1303,
        settlementType: 3,
        settlementCode: localStorage.getItem('registerId'),
        withdrawalStatus: 1
      })
        .then((res) => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 数组求和
    sum (arr) {
      var s = 0
      arr.forEach(function (val, idx, arr) {
        s += val
      }, 0)

      return s
    },
    // // 确认提现
    // tiXianClick () {
    //   if (this.$refs.tableref.selection.length != '1') {
    //     DonMessage.error('请选择一条数据进行操作')
    //   } else {
    //     this.$refs.tiXianFrom.validate((valid) => {
    //       if (valid) {
    //         let data = encryption({
    //           data: this.tiXianFrom,
    //           key: this.global.key,
    //           param: ['pwd']
    //         })
    //         let idArr = []
    //         let a = ''
    //         let orderbillNoArr = []
    //         let drawalMoneyArr = []
    //         this.tiXianLoading = true
    //         if (this.number == 0) { // 运单
    //           this.$refs.tableref.selection.forEach((item, index) => {
    //             idArr.push(item.id)
    //             orderbillNoArr.push(item.businessNo)
    //             drawalMoneyArr.push(item.totalAmount)
    //           })
    //         } else {
    //           this.$refs.tablerefD.selection.forEach((item, index) => {
    //             idArr.push(item.id)
    //             orderbillNoArr.push(item.businessNo)
    //             drawalMoneyArr.push(item.totalAmount)
    //           })
    //         }
    //         if (this.number == 0) { // 运单
    //           a = 0
    //         } else {
    //           a = 1
    //         }

    //         addWithdrawal({
    //           id: localStorage.getItem('accountId2'),
    //           settlemenIds: idArr.toString(), // 订单id，逗号分隔
    //           businessNos: orderbillNoArr.toString(), // 订单编号多个逗号分隔
    //           drawalMoney: drawalMoneyArr.toString(), // 订单金额多个逗号分隔
    //           cardholder: localStorage.getItem('cardholder2'), // 持卡人
    //           openingBank: localStorage.getItem('openingBank2'), // 开户行
    //           bankAccount: localStorage.getItem('bankAccount2'), // 银行账号
    //           pwd: data.pwd,
    //           accountType: 4
    //         }).then(res => {
    //           this.tiXianLoading = false
    //           this.tiShiMark = true
    //           this.title = '提示'
    //         }).catch(err => {
    //           this.tiXianLoading = false
    //           DonMessage.error(err.message)
    //         })
    //       }
    //     })
    //   }
    // },
    // 确认提现
    tiXianClick () {
      const selectData = this.$refs.tableref.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 10) {
        this.$alert('最多只能选择10条数据进行操作', '系统提示')
      } else {
        this.$refs.tiXianFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })

            this.zfztList = []
            this.idArr = []
            this.orderbillNoArr = []
            this.drawalMoneyArr = []
            this.tiXianLoading = true
            if (this.number == 0) { // 运单
              this.$refs.tableref.selection.forEach((item, index) => {
                this.idArr.push(item.id)
                this.orderbillNoArr.push(item.businessNo)
                this.drawalMoneyArr.push(item.totalAmount)
              })
            } else {
              this.$refs.tablerefD.selection.forEach((item, index) => {
                this.idArr.push(item.id)
                this.orderbillNoArr.push(item.businessNo)
                this.drawalMoneyArr.push(item.totalAmount)
              })
            }
            if (this.number == 0) { // 运单
            } else {
            }
            this.digui(loading)
          }
        })
      }
    },

    async digui (loading) {
      let _this = this
      let data = encryption({
        data: this.tiXianFrom,
        key: this.global.key,
        param: ['pwd']
      })
      try {
        // 构造批量请求的数据
        const withdrawalList = {
          id: localStorage.getItem('accountId2'),
          settlemenIds: this.idArr.join(','), // 订单id
          businessNos: this.orderbillNoArr.join(','), // 订单编号
          drawalMoney: this.drawalMoneyArr.join(','), // 订单金额
          cardholder: localStorage.getItem('cardholder2'), // 持卡人
          openingBank: localStorage.getItem('openingBank2'), // 开户行
          bankAccount: localStorage.getItem('bankAccount2'), // 银行账号
          pwd: data.pwd, // 密码（假设 this.pwd 是用户输入的密码）
          accountType: 4
        }

        // 发送批量请求
        const res = await addWithdrawal1(withdrawalList)
        console.log(res, 'resres')
        if (res.code === 0) {
          // if (Array.isArray(res.data) && res.data.length > 0) {
          //   res.data.forEach((item, index) => {
          //     yewu(index, item.orderNo, item.status, item.message)
          //   })
          // }
          loading.close()
          this.getListData()
          this.tiXianLoading = false
          this.$message({
            message: res.message,
            type: 'success'
          })
        } else {
          loading.close()
          this.getListData()
          this.tiXianLoading = false
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error',
            duration: 3000
          })
        }
      } catch (error) {
        console.log(error, 'error')
        this.tiXianLoading = false
        this.getListData()
        loading.close()
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error'
        })
      }

      // return
      // for (let i = 0; i < this.idArr.length; i++) {
      //   try {
      //     await addWithdrawal({
      //       id: localStorage.getItem('accountId2'),
      //       settlemenIds: this.idArr[i], // 订单id
      //       businessNos: this.orderbillNoArr[i], // 订单编号
      //       drawalMoney: this.drawalMoneyArr[i], // 订单金额
      //       cardholder: localStorage.getItem('cardholder2'), // 持卡人
      //       openingBank: localStorage.getItem('openingBank2'), // 开户行
      //       bankAccount: localStorage.getItem('bankAccount2'), // 银行账号
      //       pwd: data.pwd,
      //       accountType: 4
      //     })
      //     yewu(i, '提现成功', '24小时内可到账，请耐心等待。')
      //     this.tiXianLoading = false
      //   } catch (err) {
      //     yewu(i, '提现失败', err.message)
      //     this.tiXianLoading = false
      //   }
      // }

      function yewu (i, orderNo, zfzt, msg) {
        _this.zfztList.push({ id: _this.idArr[i], businessNo: orderNo, zfzt: zfzt, res: msg })
        if (i == _this.idArr.length - 1) {
          loading.close()
          _this.zfztMark = true
          _this.getListData()
        }
      }
    },

    tableRowClassName ({ row, rowIndex }) {
      if (row.zfzt == '提现成功') {
        return 'chenggong'
      } else {
        return 'shibai'
      }
    },
    tiShiClose () {
      this.tiShiMark = false
      this.tiXianFrom.pwd = ''
      this.allMoney = 0
      this.getTopData()
    },
    closeDialog () {
      this.tiShiMark = false
      this.tiXianFrom.pwd = ''
      this.allMoney = 0
      this.getTopData()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.pageNo = val
      this.getListData()
    },
    handleSizeChangeA (val) {
      this.pageSize = val
      this.getListData()
    },
    // 表格分页
    handleCurrentChangeD (val) {
      this.pageNo = val
      this.getListData()
    },
    handleSizeChangeD (val) {
      this.pageSize = val
      this.getListData()
    },
    // 返回
    backClick () {
      this.$router.push('/captainPay/ziJin')
    }
  }
}
</script>
<style scoped lang='less'>
.tiShiBox {
  width: 98.5%;
  height: 80px;
  background-color: #e5e5e5;
  margin: auto;
  overflow: hidden;
  color: red;
}
.bankBox {
  width: 280px;
  height: 180px;
  border: solid 1px #ccc;
  border-radius: 10px;
  margin: 0 0 0 20px;
  position: relative;
  .bank {
    text-align: center;
    margin-top: 50px;
  }
  .bankcard {
    text-align: center;
    // margin-top: 70px;
  }
}
/deep/.el-table .chenggong {
   background: #9bd67e !important;
}
/deep/.el-table .shibai {
   background: #f59191 !important;
}
/deep/.setclass{
  background: #F2E0D7;
}
</style>
